import React, { useContext, useState, useRef } from "react";
import CancelIcon from "../../../../../components/SVGComponents/CancelIcon";
import TickIcon from "../../../../../components/SVGComponents/TickIcon";
import DeletePathologyIcon from "../../../../../components/SVGComponents/DeletePathologyIcon";
import SettingIcon from "../../../../../components/SVGComponents/SettingIcon";
import DeleteIcon from "../../../../../components/SVGComponents/DeleteIcon";
import { DefaultButton, PrimaryButton, TooltipHost,Icon, getTheme } from "@fluentui/react";
import { t } from "i18next";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";

const AIPathology = (props) => {
  const { addedAnnotation, isCropEnable } = useContext(ViewportContext);
  const {themeName,getAlterColor} = useContext(themeContext);
  const {showProbablilityScores} = useContext(studyviewerContext);
  const [hover,setHover] = useState(false);
  function hexToRgb(hex, check) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result != null) {
      var r = parseInt(result[1], 16);
      var g = parseInt(result[2], 16);
      var b = parseInt(result[3], 16);
    }
    if (check) {
      return "rgb(" + r + "," + g + "," + b + ",0.5)";
    }
    return "rgb(" + r + "," + g + "," + b + ")";
  }

  const getAbbreviated = (str) =>{
      var matches = str.match(/\b(\w)/g); // ['J','S','O','N']
      var acronym = matches.join(''); // JSON
      if(acronym.length > 2){
        acronym = acronym.slice(0,2);
      }
      return acronym;
  }

  const getColorForAI = (percent) => {
    let per = 100 - percent;
    return 'hsl('+per+',100%,45%)';
  }

  const iconStyles = {
    root: {
      fontSize: '13px', // Adjust the font size as needed
      color: "#FFF"
    },
  };

  const checkForLastAddedPathology = () => {
    if(addedAnnotation?.length > 4 && addedAnnotation[addedAnnotation.length-1]?.id == props.id){
      return true;
    }
    return false;
  }

  const mouseLeaveTimeout = useRef(null);
  return (
    <div className="height-manage">
      <div style={{ marginRight: "5px", marginLeft: "20px", marginTop:'5px' }}>
        <div
          className="selected-annotation-box"
          style={{
            background: getAlterColor("rgba(0,0,0,0.4)","rgba(0,0,0,0.2)"),
            cursor: "pointer",
            border: hover
              ? `2px dashed ${props.backgroundColor}`
              : "2px solid rgb(0,0,0,0.0)",
          }}
          onMouseEnter={() => {
            if(isCropEnable) return;
            if (mouseLeaveTimeout.current) {
              clearTimeout(mouseLeaveTimeout.current); // Cancel the leave effect
              mouseLeaveTimeout.current = null;
            } else {
              props.setBBVisibleOnHover(props.id, true);
              setHover(true);
            }
          }}
          onMouseLeave={() => {
           if(isCropEnable) return;
            mouseLeaveTimeout.current = setTimeout(() => {
              props.setBBVisibleOnHover(props.id, false);
              setHover(false);
              mouseLeaveTimeout.current = null;
            }, 100);
            
          }}
          onClick={() => {
            props.handleOnClickAIPathology(props.id);
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "10px",
              cursor: "not-allowed",
              opacity:'0.5'
            }}
            onClick={(ev)=>{ev.stopPropagation();}}
          >
            <SettingIcon active={false} />
          </div>
          
          <div className="ai-tag" style={{right: checkForLastAddedPathology()?"-3px":"-8px"}}>
            <span className="ai-tag-text">{t("annotations.ai")}</span>
          </div>
          
          <div className="pathalogy-name no-margin" >{props.pathalogyName}
          {showProbablilityScores && process.env.REACT_APP_PROTECTED_MODE == "false" && <>&nbsp;-&nbsp;{props.aiPercent}%</>}
          </div>
          {/* <div
            className="ai-percent-box"
            style={{ background: getColorForAI(props.aiPercent) }}
          >
            <span className="ai-percent-text">{props.aiPercent}%</span>
          </div> */}

           <div className="tick-icon">
           <div className="background-delete-pathology" 
            onClick={(ev) => {
              ev.stopPropagation();
              props.removeBB(props.id);
              setHover(false);
              props.addOrRemoveAnnotation(props.id, 0);
            }}
            >
           <Icon
              
              iconName="Delete"
              styles={iconStyles}
            />
            </div>
            
            
          </div>
        
        
        </div>
      </div>
    </div>
  );
};

export default AIPathology;
